export default __webpack_public_path__ + "static/media/temp_profile_icon.47fde32f.png";